import React from "react";
import { Navigate, useParams } from "react-router-dom";
import GameShell from "./GameShell";
import ClickToWin from "./ClickToWin";
import SlotGame from "./SlotGame";
import TypeAnswers from "./TypeAnswers";
import WordPuzzle from "./WordPuzzle";
import useDesiGame from "./useDesiGame";
import useDesiBackground from "./useDesiBackground";
import { GAME_BY_KEY, WELCOME_ROUTE } from "./gameConfig";
import "./desi.css";

const VIEWS = {
  bengal: ClickToWin,
  maharashtra: ClickToWin,
  gujarat: SlotGame,
  punjab: TypeAnswers,
  andhra: WordPuzzle,
  karnataka: TypeAnswers,
};

function Play({ gameKey }) {
  const api = useDesiGame(gameKey);
  const View = VIEWS[gameKey];
  useDesiBackground();

  if (!api.ready) {
    return (
      <div className="desi-loader">
        <div className="quiz-loader" />
      </div>
    );
  }

  return (
    <GameShell
      gameKey={gameKey}
      timeLabel={api.timeLabel}
      score={api.score}
      onSkip={api.skip}
      skipDisabled={api.saving}
    >
      <View gameKey={gameKey} api={api} />
    </GameShell>
  );
}

/** /play/:gameKey — one of the six state games. */
export default function PlayGame() {
  const { gameKey } = useParams();
  if (!GAME_BY_KEY[gameKey]) return <Navigate to={WELCOME_ROUTE} replace />;
  return <Play key={gameKey} gameKey={gameKey} />;
}
